module.exports = __webpack_public_path__ + "img/login-illustration.2ea48a1d.png";